import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { TransplantSource as MyType } from '@shapeable/kelp-forest-alliance-types';
const gql = String.raw;

export const TransplantSource: EntityConfig<MyType> = {
  name: 'TransplantSource',
  type: 'taxonomy',
  icon: ({ icons }) => icons.Entities.Target,
  autoRoutes: ['list', 'create', 'update'],
  form: {
    fields: {
      ...entityStandardFormFields,
      description: { type: 'longText' },
    }
  }
};